import { render, staticRenderFns } from "./GiftBoardCard.vue?vue&type=template&id=502560a8&scoped=true&"
import script from "./GiftBoardCard.vue?vue&type=script&lang=js&"
export * from "./GiftBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoardCard.vue?vue&type=style&index=0&id=502560a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502560a8",
  null
  
)

export default component.exports